export class ProductCondition {
    id: number;
    description: string;
    descriptionFr: string;
    status: string;
}